import * as classnames from "classnames";
import * as React from "react";

import { injectIntl, IReactIntlProps } from "../../common/extensions";
import { Common } from "../../common/messages";
import { Button } from "@mui/material";
import { MessageDescriptor } from "react-intl";
import { Common as SharedCommon } from "tp/shared/common/messages";

interface ButtonProps extends IReactIntlProps {
    onClick: () => void;
    disabled?: boolean;
}

export function buttonBuilder(buttonTypeClassName: string, message: MessageDescriptor): React.ComponentClass<ButtonProps> {

    class ButtonClass extends React.Component<ButtonProps, Record<string, unknown>> {
        render() {

            const className = classnames("tc-button", buttonTypeClassName, { active: !this.props.disabled });

            return <Button
                className={className}
                onClick={this.props.onClick}
                variant="contained"
                color="primary"
                disabled={this.props.disabled}
            >
                {this.props.intl.formatMessage({ ...message })}
            </Button>;
        }
    }
    return injectIntl(ButtonClass);
}

export const SaveButton = buttonBuilder("", Common.save);
export const CancelButton = buttonBuilder("tc-cancel", SharedCommon.Cancel);
export const YesButton = buttonBuilder("yes", Common.yes);
export const NoButton = buttonBuilder("no", Common.no);
export const BackButton = buttonBuilder("back", Common.back);
export const NewButton = buttonBuilder("new", Common.new);
